<template>
  <div>
    <table class="table mt-0 table-sm table-hover">
      <thead>
      <tr>
        <th width="40px"></th>
        <th class="small_th"></th>
        <th>Препарат</th>
        <th class="medium_th">ожидаемое</th>
        <th class="medium_th">фактическое</th>
        <th width="50px"></th>
        <th class="medium_th">стоимость</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="(r, index) in recordsToEdit" :key="r.id">
        <td>{{ index + 1 }}</td>
        <td>
          <DetailCommentBlock
            :invoice="invoice"
            :detail="r"
          />
        </td>
        <td>
          <template v-if="r?.drug?.id">
            <div class="input-group">
              <input :value="r?.drug?.title" disabled type="text" class="form-control">
            </div>
          </template>
          <template v-else>
            <DrugSearchNew
              :ref="`search_drug_${index}`"
              :selectedDrug="r.drug"
              :searchOptions="{currencyId: invoice.currency_id}"
            />
            <!--            :onSelect="(d) => addDrug(index, detail?.drug?.id, d)"-->
          </template>
          <div v-if="r.files.length">
            <PreviewPage :files="r.files" :hidePreview="true"/>
          </div>
        </td>
        <td><input :value="r.qty" disabled type="text" class="form-control"></td>
        <td><input v-model="r.income_qty" type="number" class="form-control"></td>
        <td>
          <DrugTraceTooltip :records="invoice.trace.filter((t) => t.object === 'drug' && t.object_id === r.drug_id)"/>
        </td>
        <td><input v-model="r.income_price" type="text" class="form-control"></td>
      </tr>
      <tr v-if="passRecords.length" class="bg_success">
        <td colspan="10">Препараты без изменений количества</td>
      </tr>
      <tr v-for="(r, index) in passRecords" :key="r.id">
        <td>{{ index + 1 }}</td>
        <td>
          <DetailCommentBlock
            :invoice="invoice"
            :detail="r"
          />
        </td>
        <td><input :value="r?.drug?.title" disabled type="text" class="form-control"></td>
        <td><input :value="r.income_qty" disabled type="text" class="form-control"></td>
        <td><input v-model="r.qty" type="number" class="form-control"></td>
        <td colspan="5"><input v-model="r.income_price" type="text" class="form-control"></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>

import DetailCommentBlock from "@/views/admin/invoices/components/DetailCommentBlock.vue";
import DrugSearchNew from "@/components/drugs/DrugSearchNew.vue";
import PreviewPage from "@/components/files/PreviewPage.vue";
import DrugTraceTooltip from "@/views/admin/invoices/components/DrugTraceTooltip.vue";

export default {
  components: {DrugTraceTooltip, PreviewPage, DrugSearchNew, DetailCommentBlock},
  props: ['invoice', 'records'],
  data() {
    return {
      recordsToEdit: [],
      passRecords: []
    }
  },
  created() {
    this.recordsToEdit = this.records.filter((r) => !r.drug_id || r.qty !== r.income_qty);
    const ids = this.recordsToEdit.map((r) => r.id);
    this.passRecords = this.records.filter((r) => !ids.includes(r.id));
  },
  methods: {}
}

</script>

<style scoped>
.small_th {
  width: 70px;
}

.medium_th {
  width: 130px;
}
</style>
